import { useTranslation } from 'react-i18next'

import { getEntityProfileTabs } from '../../../../Entity'
import { Skeleton } from '../../../../Skeleton'
import { TabScrollList } from '../../../../Tab'
import { getListingProfileTabsWithAttentionDot } from '../../../RentalPortal.utils'
import {
  useListingProfileContext,
  useListingProfileTabsActiveTab,
} from '../RentalPortalListingProfile.hooks'

import { LISTING_PROFILE_TAB_LIST } from './RentalPortalListingProfileTabs.constants'
import { getListingProfileTabCounters } from './RentalPortalListingProfileTabs.utils'

import * as styles from './RentalPortalListingProfileTabs.module.css'

function RentalPortalListingProfileTabs() {
  const { t } = useTranslation()

  const { isInitiated, listingData } = useListingProfileContext()

  const preparedTabs = getListingProfileTabsWithAttentionDot({
    dotClassName: styles.attentionDot,
    preparedTabs: getEntityProfileTabs({
      counters: getListingProfileTabCounters(listingData),
      entityData: listingData,
      t,
      tabs: LISTING_PROFILE_TAB_LIST,
    }),
    tabsAwaitingYou: listingData?.attention?.tabs_awaiting_you,
    tooltip: t('RentalPortal.ListingProfileTabAwaitingYouTooltipKey'),
  })

  const { activeTabId, handleSetActiveTab } = useListingProfileTabsActiveTab({
    listingData,
    preparedTabs,
  })

  const ActiveTabContent = LISTING_PROFILE_TAB_LIST.find(
    tab => tab.id === activeTabId
  )?.Content

  return isInitiated ? (
    <>
      <TabScrollList
        activeTab={activeTabId}
        preparedTabs={preparedTabs}
        wrapperClassName={styles.tabsWrapper}
        onSetActiveTab={handleSetActiveTab}
      />
      {ActiveTabContent ? <ActiveTabContent /> : null}
    </>
  ) : (
    <Skeleton className={styles.skeleton} />
  )
}

export default RentalPortalListingProfileTabs
